import { Component, OnInit, Input } from '@angular/core';
import { LangService } from 'src/app/services/lang/lang.service';
import { CmsService } from 'src/app/services/api/cms.service';
import { FirebaseService } from 'src/app/services/firebase.service';
import { CustomerService } from 'src/app/services/api/customer.service';
import { WinService } from 'src/app/services/win.service';
import { SocketioService } from 'src/app/services/socketio.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { DragonpayProcBecomeUnavailableComponent } from 'src/app/components/modals/dragonpay-proc-become-unavailable/dragonpay-proc-become-unavailable.component';
import { WalletService } from 'src/app/services/api/wallet.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {

	@Input() onClose: any = null;
	@Input() order: any = null;
	
	private modalRef : BsModalRef;

	fileName: any = null;
	file: any = null;
	uploading: boolean = false;
	bank_deposit_ins: any; /** ins means instruction */
	activeItem: any;
	paymaya_ins: any; /** ins means instruction */
	payment_method: any;
	address: any;
	cebuana_lhuillier: any;
	mlhuillier: any;
	jsonData: any;
	counter: any;
	fileLength: any;
	path: string;
	paypal_ins: any; /** ins means instruction */
	metrobank_ins: any; /** ins means instruction */
	banco_de_oro_ins: any; /** ins means instruction */
	bpi_ins: any; /** ins means instruction */
	lbc_ins: any; /** ins means instruction */
	dragonpay_ins: any; /** ins means instruction */
	others_ins: any; /** ins means instruction */
	wallet_ins: any; /** ins means instruction */

	paymentView: string = 'list';

	constructor(
		public lang : LangService,
		public  winService: WinService,
		public firebaseService: FirebaseService,
		public cmsService : CmsService,
		public customerService: CustomerService,
		public socketioService: SocketioService,
		public modalService: BsModalService,
		public walletService: WalletService
	) { }

	ngOnInit() {
		this.getDragonpayProc(this.order.base_grand_total).then( (procs:any) => {
			let ai = this.order.payment.additional_information;

			if(typeof ai.dragonpay_procid != 'undefined'){
				this.isProcSelected = true;
				this.selectedDragonpayProcessor = ai.dragonpay_procid.replace('dragonpay_via_', '');
			}
			// ai.forEach(val => {
			// 	if(val.indexOf('dragonpay_via_') == 0){
			// 		this.isProcSelected = true;
			// 		this.selectedDragonpayProcessor = val.replace('dragonpay_via_', '');
					
			// 		procs.forEach(proc => {
			// 			if(proc.procId == this.selectedDragonpayProcessor){
			// 				this._selectedDragonpayProcessor = proc;
			// 			}
			// 		});
			// 	}
			// });
		});

		this.getDragonpayProcForCashin();

		this.cmsService.getBlockv2(11, true, false).then(res => {
			this.paymaya_ins = res;
		});

		this.cmsService.getBlockv2(51, true, false).then(res => {
			this.dragonpay_ins = res;
		});

		this.cmsService.getBlockv2(73, true, false).then(res => {
			this.wallet_ins = res;
		});
	}

	/**
	 * open the file browser to prepare upload
	 */
	openFileBrowser(event: any){
		event.preventDefault();
		let el: HTMLElement = document.getElementById('payment_proof_input') as HTMLElement;
		el.click();
	}

	/**
	 * prepare the file to be uploaded on firestore
	 */
	prepareFile(event){
		let fName = event.target.files[0].name;
		let ext = fName.split('.');
		ext = ext[ext.length - 1];
		ext = ext.toLowerCase();

		if(ext == 'jpg' || ext == 'jpeg' || ext == 'png'){
			this.fileName = fName;
			this.file = event;
		} else {
			this.fileName = null;
			this.file = null;
			this.cmsService.toastService.add('Please upload jpg, jpeg or png files only', 'danger');
		}
	}

	orig_base_total: any = 0;
	activatePaymentMethod(activeItem){

		if(this.payment_method === activeItem){
			this.payment_method = null;
		}else{
			this.payment_method = activeItem;
			this._selectedDragonpayProcessor = null;
			this.selectedDragonpayProcessor = null;
			this.reCalculateHandlingFee();
			
			this.isProcSelected = false;
		}
	}

	paymayaFee() {
		let subtotal = this.order.subtotal - this.order.discount_amount + this.order.shipping_amount;
        subtotal = this.order.base_grand_total - subtotal;

		return subtotal;
	}

	/**
	 * start upload to google fire store
	 * return promise
	 */
	upload() {
		this.uploading = true;
		this.jsonData = {
			"others": []
		};
		this.path = 'order/quote_'+this.order.quote_id + '/payment_proof_';
		
		this.fileLength = this.file.target.files.length;
		this.uploading = false;
		this.counter = 0;
		this.startUpload();
	}

	startUpload(){
		if(this.fileLength > this.counter){
			if(!this.uploading){
				this.uploading = true;

				this.firebaseService
				.setFile(this.file)
				.setPath(this.path)
				.getGenerateName().then(filename => {
					this.firebaseService.upload(this.counter).then(url => {
						this.uploading = false;
						
						if(url){
							let data = {
								"firestore_link": url,
								"firestore_task": {
									"uploadUrl_": this.firebaseService.task.task.uploadUrl_,
									"location": this.firebaseService.task.task.location_,
									"metadata_": this.firebaseService.task.task.metadata_,
									"filename": 'payment_proof_' + this.firebaseService.newFilename
								}
							};
							this.jsonData.others.push(data);
							
							if((this.counter+1) == this.fileLength){
								
								this.cmsService.makeRequest('/rest/entrelable/V1/lns-api/orders/payment/proof/'+this.order.entity_id, this.jsonData, 'POST').then(proof => {
									if(proof){
										let p: any = proof;
										p = p[0];
										this.order.status = p.status;
									}
									this.onClose();
									this.cmsService.setLoader(false);
								});
								this.file = null;
								this.fileName = null;
							}
							this.counter++;
							this.startUpload();
						} else {
							/* resolve(null); */
						}
					});
				});
			}
		}
		
	}

	continueToPayMaya(){
		this.customerService.setLoader(true);
		this.customerService.makeRequest('/rest/entrelable/V1/lns-payments/paymaya/'+this.order.entity_id, '', 'GET')
		.then(paymaya => {
			let pm: any = paymaya
			if(pm[0]){
				window.location = pm[0].redirectUrl;
			}
			this.customerService.setLoader(false);
		});
	}

	useWallet(){
		if(this.payment_method == 'wallet'){
			this.customerService.setLoader(true);
			let url = this.customerService.getStoreUrl('/V1/hnd-wallet/order/payment/'+this.order.entity_id+'/use/wallet');
			this.customerService.makeRequest(url, {
				"is_use_wallet": true
			}, 'POST')
			.then(response => {
				if(response){
					window.location.reload();
				}
				this.customerService.setLoader(false);
			});
		}
	}

	/**
	 * dragonpay part
	 */
	dragonpayProcessors: any = null;
	_selectedDragonpayProcessor: any = null;
	selectedDragonpayProcessor: any = null;
	isProcSelected: boolean = false;

	dragonpayProcessorsForCashin: any = null;
	dragonpayProcessorsForCashinList1: any = null;
	dragonpayProcessorsForCashinList2: any = null;

	isProcSelectedForCashin: any = null;
	_selectedDragonpayProcessorForCashin: any = null;
	selectedDragonpayProcessorForCashin: any = null;

	/**
	 * get the dragonpay's available processors depending on
	 * total ammount of the order
	 */
	getDragonpayProc(ammount:any = 0){
		return new Promise(procs => {
			let url = this.customerService.getStoreUrl('/V1/lns-dragonpay/available/processors?ammount=' + ammount)
			this.customerService.setLoader(true);
			this.customerService.makeRequest(url, '', 'GET').then(resolve => {
				let r: any = resolve;
				this.dragonpayProcessors = r;
				procs(this.dragonpayProcessors);
				this.customerService.setLoader(false);
			});
		});
	};

	getDragonpayProcForCashin(){
		return new Promise(res => {
			let totalPayment = 0;
			this.order.extension_attributes.hnd_payment_history.forEach(hnd_payment_history => {
				totalPayment += parseFloat(hnd_payment_history.amount_paid);
			});
			let remainingBalance = Number(this.order.grand_total - totalPayment);

			let wallet = Number(this.walletService.wallet?.wallet) ?? 0;
			if(wallet.toFixed(2) >= remainingBalance.toFixed(2)){
				this.dragonpayProcessorsForCashin = null;
				this.dragonpayProcessorsForCashinList1 = null;
				this.dragonpayProcessorsForCashinList2 = null;
				res(true);
			}
			else {
				let url = this.customerService.getStoreUrl('/V1/hnd-wallet/mine/cashin/dragonpay/procs/' + remainingBalance);
				this.customerService.setLoader(true);
				this.customerService.makeRequest(url, '', 'GET').then(resolve => {
					let r: any = resolve;

					this.dragonpayProcessorsForCashin = r;

					let lastKey = (this.dragonpayProcessorsForCashin.length / 2) - 1;
					this.dragonpayProcessorsForCashinList1 = [];
					this.dragonpayProcessorsForCashinList2 = [];
					this.dragonpayProcessorsForCashin.forEach((val, key) => {
						if(key <= lastKey){
							this.dragonpayProcessorsForCashinList1.push(val);
						}
						if(key > lastKey){
							this.dragonpayProcessorsForCashinList2.push(val);
						}
					});

					res(true);
				});
			}
		});
	}

	get getDragonpayProc1(){
		let lastKey = (this.dragonpayProcessors.length / 2) - 1;
		let procs = [];
		this.dragonpayProcessors.forEach((val, key) => {
			if(key <= lastKey){
				procs.push(val);
			}
		});
		return procs;
	}

	get getDragonpayProc2(){
		let lastKey = (this.dragonpayProcessors.length / 2) - 1;
		let procs = [];
		this.dragonpayProcessors.forEach((val, key) => {
			if(key > lastKey){
				procs.push(val);
			}
		});
		return procs;
	}

	setDragonpayProcessors(proc:any = null){
		if(proc){
			this._selectedDragonpayProcessor = proc;
			this.selectedDragonpayProcessor = proc.procId;
			this.reCalculateHandlingFee();
		} else {
			this.selectedDragonpayProcessor = null
		}
		this.isProcSelected = true;
	}

	setDragonpayProcessorsForCashin(proc:any = null){
		if(proc){
			this._selectedDragonpayProcessorForCashin = proc;
			this.selectedDragonpayProcessorForCashin = proc.procId;
		} else {
			this.selectedDragonpayProcessorForCashin = null
		}
		this.isProcSelectedForCashin = true;
	}

	checkDragonPayProcForCashinAvailability(){
		this.socketioService.emitToSelf('check_dragonpay_proc', this._selectedDragonpayProcessorForCashin, (isValid:any)=>{

			if(isValid){
				this.goToDragonpayForCashin();
			}
			else {
				let config: ModalOptions = {
					backdrop: "static",
					keyboard: false,
					animated: true,
					ignoreBackdropClick: true,
					initialState: {
						selectedDragonpayProc: this._selectedDragonpayProcessorForCashin
					}
				}
				this.modalRef = this.modalService.show(DragonpayProcBecomeUnavailableComponent, config);
				this.modalRef.setClass('modal-dialog-centered');
				this.modalRef.content.onClose = () => {
					this.customerService.setLoader(true);
				
					this.getDragonpayProcForCashin().then(() => {
						this.modalRef.hide();
						this._selectedDragonpayProcessorForCashin = null;
						this.selectedDragonpayProcessorForCashin = null;
						this.isProcSelectedForCashin = false;
						this.customerService.setLoader(false);
					});
				};
			}
		});
	}

	checkDragonPayProcAvailability(){
		this.socketioService.emitToSelf('check_dragonpay_proc', this._selectedDragonpayProcessor, (isValid:any)=>{
			if(isValid){
				this.goToDragonPay();
			}
			else {
				let config: ModalOptions = {
					backdrop: "static",
					keyboard: false,
					animated: true,
					ignoreBackdropClick: true,
					initialState: {
						selectedDragonpayProc: this._selectedDragonpayProcessor
					}
				}
				this.modalRef = this.modalService.show(DragonpayProcBecomeUnavailableComponent, config);
				this.modalRef.setClass('modal-dialog-centered');
				this.modalRef.content.onClose = () => {
					this.customerService.setLoader(true);
				
					this.getDragonpayProc(this.order.base_grand_total).then(() => {
						this.modalRef.hide();
						this._selectedDragonpayProcessor = null;
						this.selectedDragonpayProcessor = null;
						this.isProcSelected = false;
						this.customerService.setLoader(false);
					});
				};
			}
		});
	}

	/**
	 * redirect the site in the dragonpay dashboard
	 * @param orderId 
	 */
	goToDragonPay(){
		let url = '/V2/lns-dragonpay/order/token/' + this.order.entity_id + '/' + this.selectedDragonpayProcessor + '?';
		url = this.customerService.getStoreUrl(url);

		this.customerService.setLoader(true);
		this.customerService.makeRequest(url, '', 'GET').then((result:any) => {
			window.location.href = result.Url;
		});
	}

	goToDragonpayForCashin(){
		let selectedMethod = 'dragonpay';
		let url =  '/V1/hnd-wallet/mine/cashin/'+selectedMethod+'/link';
		url = this.customerService.getStoreUrl(url);

		let amount = (this.order.subtotal - this.order.discount_amount + this.order.shipping_amount) - this.walletService.wallet.wallet;
		// do not include handling fee
		// amount += this._selectedDragonpayProcessorForCashin.handling_fee;

		let jsonData = {
			"amount": amount,
			"proc_id": this.selectedDragonpayProcessorForCashin,
			"payment_method": "dragonpay",
			"order_id": this.order.entity_id,
			"notifications": {
				email: this.order.billing_address.email,
				mobile_number: this.order.billing_address.telephone,
			},
			"selected_cashin_amount": {
				amount: "0.00",
				identifier: "manual_amount",
				voucher_code: []
			}
		}
		this.customerService.setLoader(true);
		this.customerService.doRequest(url, jsonData, "POST").then((response: any) => {
			window.location.href = response.result.others.dragonpay_link.Url;
		});
	}

	/**
	 * end of dragonpay part
	 */

	reCalculateHandlingFee(){
		this.customerService.setLoader(true);
		this.reCalculateHandlingFeeRequest().then(order => {
			if(order){
				this.order.base_grand_total = order['order']['base_grand_total'];
				this.order.grand_total = order['order']['grand_total'];
				this.order.total_due = order['order']['total_due'];
				this.order.base_total_due = order['order']['base_total_due'];
	
				this.order.payment.additional_information = order['payment']['additional_information'];
				this.order.payment.amount_ordered = order['payment']['amount_ordered'];
				this.order.payment.base_amount_ordered = order['payment']['base_amount_ordered'];
				this.order.payment.method = order['payment']['method'];
			}
				
			this.customerService.setLoader(false);
		});
	}

	reCalculateHandlingFeeRequest(){
		return new Promise(res => {
			
			let url = '/rest/entrelable/V1/hnd-order/orders/handling-fee';

			let jsonData = {
				"order_id": this.order.entity_id,
				"new_payment_method": this.payment_method,
				"is_ignore_wallet": true
			}
			if(this.selectedDragonpayProcessor){
				jsonData['procid'] = this.selectedDragonpayProcessor;
			}

			this.customerService.makeRequest(url, jsonData, 'POST', true, false).then(order => {
				let o:any = order;
				if(o){
					res(order[0]);
				} else {
					res(null);
				}
			});
		});
	}
}
